import script from "./TrendingFranchises.vue?vue&type=script&setup=true&lang=js"
export * from "./TrendingFranchises.vue?vue&type=script&setup=true&lang=js"

import "./TrendingFranchises.vue?vue&type=style&index=0&id=b3d1b218&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3d1b218"]])

export default __exports__